/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
// import {ServerResponse} from '../interfaces/ServerResponse';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
// import {ServerError} from '../models/server-error.model';
import {SMSBalance, SMSMessage, SMSPredefined} from '../models/sms.model';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {DialogNewSiteComponent} from '../modules/website-control-center/my-sites/dialogs/dialog-new-site/dialog-new-site.component';
import {MatDialog} from '@angular/material/dialog';

@Injectable({providedIn: 'root'})
export class SmsService {

	sendSMS(originator: string, csPhoneNumbers: string,	messageBody: string, messageIsFlash: boolean): Observable<any> {
		return this.http.post(
			API_ENDPOINTS.SMS.SMS_SEND_NEW,
			{
				originator: originator,
				csPhoneNumbers: csPhoneNumbers,
				messageBody: messageBody,
				messageIsFlash: messageIsFlash
			}
		);
			// .pipe(
			// 	// map((response: ServerResponse) => {
			// 	map((response: any) => {
			// 		if (!response.error) {
			// 			return true;
			// 		} else {
			// 			return false;
			// 		}
			// 	})
			// );
	}

	getSmsAccountBalance(): Observable<SMSBalance> {
		return this.http.post(
			API_ENDPOINTS.SMS.SMS_GET_ACCOUNT_BALANCE,
			{}
		)
			.pipe(
				// map((response: ServerResponse) => {
				map((response: any) => {
					if (!response.error) {
						return new SMSBalance(response.message.payment, response.message.type, response.message.amount);
					} else {
						return new SMSBalance('', '', -1);
					}
				})
			);
	}

	getSmsHistory(): Observable<SMSMessage[]> {
		return this.http.post(
			API_ENDPOINTS.SMS.SMS_GET_ACCOUNT_HISTORY,
			{}
		)
			.pipe(
				// map((response: ServerResponse) => {
				map((response: any) => {
					if (!response.error) {
						return this.toSMSArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	getPredefinedSms(): Observable<SMSPredefined[]> {
		return this.http.post(
			API_ENDPOINTS.SMS.SMS_GET_PREDEFINED,
			{}
		)
			.pipe(
				// map((response: ServerResponse) => {
				map((response: any) => {
					if (!response.error) {
						return this.toSMSPredefinedArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	private toSMSArray(data): SMSMessage[] {
		const SMSes: SMSMessage[] = [];
		for (const item of data.items) {
			SMSes.push(
				new SMSMessage(
					StringFunctions.emptyToNull(item.originator),
					StringFunctions.emptyToNull(item.body),
					new Date(item.createdDatetime).toLocaleDateString('el'),
					item.recipients.totalSentCount,
					item.recipients.totalDeliveredCount,
					StringFunctions.emptyToNull(item.recipients.items[0].recipient.toString()),
					StringFunctions.emptyToNull(item.status),
				)
			);
		}
		return SMSes;
	}

	private toSMSPredefinedArray(data): SMSPredefined[] {
		const SMSes: SMSPredefined[] = [];
		for (const item of data) {
			SMSes.push(
				new SMSPredefined(
					parseInt(item.Id, 10),
					StringFunctions.emptyToNull(item.Body),
				)
			);
		}
		return SMSes;
	}

	constructor(private http: HttpClient) { }

}
